import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);

    try {
      await register(email, password);
      navigate('/explore/octants');
    } catch (err) {
      setError(err.response?.data?.detail || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="glass-card rounded-xl p-8 w-full max-w-md">
        <div className="flex flex-col items-center mb-6">
          <img 
            src="/logo.png" 
            alt="Rook Games" 
            className="h-20 w-20 object-contain mb-4"
            data-testid="register-logo"
          />
          <h1 className="text-4xl font-bold text-center text-primary">KRAKEN</h1>
          <p className="text-center text-muted-foreground mt-2">Create your explorer account</p>
        </div>

        {error && (
          <div className="bg-destructive/10 border border-destructive text-destructive rounded-lg p-3 mb-4" data-testid="error-message">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-2 bg-white/5 border border-cyan-400/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-400 text-foreground"
              required
              data-testid="email-input"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-2 bg-white/5 border border-cyan-400/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-400 text-foreground"
              required
              data-testid="password-input"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">Confirm Password</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full px-4 py-2 bg-white/5 border border-cyan-400/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-400 text-foreground"
              required
              data-testid="confirm-password-input"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 bg-cyan-500/90 hover:bg-cyan-400 text-slate-900 font-semibold rounded-lg btn-glow disabled:opacity-50 transition-all"
            data-testid="register-button"
          >
            {loading ? 'Creating account...' : 'Register'}
          </button>
        </form>

        <p className="text-center mt-6 text-sm text-muted-foreground">
          Already have an account?{' '}
          <Link to="/login" className="text-primary hover:underline" data-testid="login-link">
            Login
          </Link>
        </p>

        <p className="text-center mt-4 text-xs text-muted-foreground">
          You'll start with 500 credits to explore the universe
        </p>
      </div>
    </div>
  );
}

export default Register;
